import React from "react"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import classes from "./SsProfile.module.scss"

const SsProfile = () => {
  const [t] = useTranslation()

  const { fullName, branchName } =
    useSelector(state => state.userAccountInfo)

  return (
    <div className={classes["container"]}>
      <div className={classes["fullname"]}>
        {t("نام")}: {fullName}
      </div>
      <div className={classes["branch"]}>
        {t("شعبه")}: {branchName}
      </div>
    </div>
  )
}

export default SsProfile